var render, staticRenderFns
import script from "./QSnapshotAgentsDataTable.vue?vue&type=script&lang=js&"
export * from "./QSnapshotAgentsDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QSnapshotAgentsDataTable.vue?vue&type=style&index=0&id=bff080aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff080aa",
  null
  
)

export default component.exports